import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14a125cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "web_top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "你好，欢迎使用数农在线财务管理系统", -1))
const _hoisted_3 = { class: "web_top_right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_CustomerServiceOutlined = _resolveComponent("CustomerServiceOutlined")!
  const _component_LogoutOutlined = _resolveComponent("LogoutOutlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_button, {
        type: "block",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showinteraction('暂未开放')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_UserOutlined),
          _createTextVNode("用户 ")
        ]),
        _: 1
      }),
      _createVNode(_component_a_button, {
        type: "block",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showinteraction('暂未开放')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_CustomerServiceOutlined),
          _createTextVNode("在线客服 ")
        ]),
        _: 1
      }),
      _createVNode(_component_a_button, {
        type: "block",
        onClick: $setup.logOutFun
      }, {
        default: _withCtx(() => [
          _createVNode(_component_LogoutOutlined),
          _createTextVNode("安全退出 ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}